module.exports = __webpack_public_path__ + "static/img/主图.ccc440c.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/match_result/figure/结果页/爱自己/谢昌华/主图.png
// module id = oKHM
// module chunks = 1